var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileDeleteBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00556 6.50018L0.877808 11.6279L1.87231 12.6224L7.00006 7.49468L12.1278 12.6224L13.1223 11.6279L7.99456 6.50018L13.1223 1.37243L12.1278 0.37793L7.00006 5.50568L1.87231 0.37793L0.877808 1.37243L6.00556 6.50018Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDeleteBtn);
export default __webpack_public_path__ + "static/media/icon_file_delete_btn.d7b314fa77f70918ec4bcc38f8d6e610.svg";
export { ForwardRef as ReactComponent };